import {BaseRepository} from "../../../infrastructure/repositories/base-repository";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {AthleteGameLineupsFactory} from "./athlete-game-lineups.factory";
import {AthleteGameLineupsApiService} from "./athlete-game-lineups.api-service";

export class AthleteGameLineupsRepository extends BaseRepository {
  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, AthleteGameLineupsApiService, AthleteGameLineupsFactory];
}
